/* Page compania scripts
========================================================================== */

if (jQuery('#pagina-lacompania').length !== 0 || jQuery('#pagina-alumnado').length !== 0) {
	let barras_superiores_contenidos_items = document.querySelectorAll('.barra-superior-contenido-item');
	for (let i = 0; i < barras_superiores_contenidos_items.length; i++) {
		barras_superiores_contenidos_items[i].addEventListener('click', mostrar_contenido_item_acordeon);
	}

	function mostrar_contenido_item_acordeon() {
		// ESTE IF ES POR SI PULSA EN UNO ABIERTO PARA QUE SE CIERRE
		if (this.lastElementChild.classList.value == 'abierto') {
			this.nextElementSibling.classList.add('ocultar-contenido-item');
			this.lastElementChild.classList.remove('abierto'); // El signo de la derecha
			return;
		}

		let barras_superiores_contenidos_items = document.querySelectorAll('.barra-superior-contenido-item');
		// for se cierran todos
		for (let i = 0; i < barras_superiores_contenidos_items.length; i++) {
			barras_superiores_contenidos_items[i].nextElementSibling.classList.add('ocultar-contenido-item');
			barras_superiores_contenidos_items[i].lastElementChild.classList.remove('abierto'); // El signo de la derecha

		}
		// for se abre el indicado
		for (let i = 0; i < barras_superiores_contenidos_items.length; i++) {
			if (barras_superiores_contenidos_items[i] === this) {
				this.nextElementSibling.classList.toggle('ocultar-contenido-item');
				this.lastElementChild.classList.toggle('abierto'); // El signo de la derecha
			}
		}
	}
}
